import { useNavigateSearch } from "@/hooks/useNavigate";
import { useUrlFilters } from "@/features/shared/hooks/useUrlFilters";

interface UseRuleCreationTypeSelectorReturn {
  onSelectExcessRule: () => void;
  onSelectMinimumRule: () => void;
  onSelectRecurrenceRule: () => void;
}

export const useRuleCreationTypeSelector =
  (): UseRuleCreationTypeSelectorReturn => {
    const navigateSearch = useNavigateSearch();
    const { getFilter } = useUrlFilters();

    // Get fiscalNumber and ownerId from URL parameters to preserve them
    const fiscalNumber = getFilter("fiscalNumber");
    const ownerId = getFilter("ownerId");

    const onSelectExcessRule = () => {
      navigateSearch("/cash-pooling/rule-creation/excess", {
        fiscalNumber,
        ownerId,
      });
    };

    const onSelectMinimumRule = () => {
      navigateSearch("/cash-pooling/rule-creation/minimum", {
        fiscalNumber,
        ownerId,
      });
    };

    const onSelectRecurrenceRule = () => {
      navigateSearch("/cash-pooling/rule-creation/fixed", {
        fiscalNumber,
        ownerId,
      });
    };

    return {
      onSelectExcessRule,
      onSelectMinimumRule,
      onSelectRecurrenceRule,
    };
  };
